module.exports = __webpack_public_path__ + "img/05.05b4aa59.png";